export default __webpack_public_path__ + "static/media/bot.17f2898c.png";